import React from 'react';
import PropTypes from 'prop-types';
import { NotStarted, InProgress, Complete } from './styled';
import { NOT_STARTED, WORK_IN_PROGRESS, COMPLETE } from './constants';
import { toLower } from '../../../../util/lodashlike';

/**
 * Status
 * @param type {string}
 * @returns {JSX.Element}
 */
const Status = ({ type = NOT_STARTED }) => {
  const matchType = toLower(type);

  return (
    <>
      {matchType === NOT_STARTED && <NotStarted>{NOT_STARTED}</NotStarted>}
      {matchType === WORK_IN_PROGRESS && (
        <InProgress>{WORK_IN_PROGRESS}</InProgress>
      )}
      {matchType === COMPLETE && <Complete>{COMPLETE}</Complete>}
    </>
  );
};

Status.propTypes = {
  type: PropTypes.string
};

export default Status;
